import {
  List,
  Datagrid,
  TextField,
  DateField,
  SimpleList,
  EditButton,
  ShowButton,
  ListActions,
  ReferenceField,
  TextInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";

const filters = [
  <TextInput
    source="nameBg"
    label="Име"
    alwaysOn
  />,
  <ReferenceInput
    source="structuralUnitId"
    reference={administrationRequests.getStructuralUnitsSelect()}
    filter={{ filterByUser: true }}
    alwaysOn
  >
    <SelectInput label="Структурна единица" />
  </ReferenceInput>,
];

const ListCampaigns = () => {
  const isSmall = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      filters={filters}
      exporter={false}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageSpecialistCampaigns)} />}
    >
      {isSmall ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Начало на регистрация",
                    value: (
                      <DateField
                        source="registrationStartsOn"
                        label="Начало на регистрация"
                        locales="bg-BG"
                        showTime
                        sortable={false}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Край на регистрация",
                    value: (
                      <DateField
                        source="registrationEndsOn"
                        label="Край на регистрация"
                        locales="bg-BG"
                        showTime
                        sortable={false}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Структурна единица",
                    value: (
                      <ReferenceField
                        source="structuralUnitId"
                        reference={administrationRequests.getStructuralUnitsSelect()}
                        label="Структурна единица"
                        sortable={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => (
            <>
              <SecuredComponent permission={permissions.canManageSpecialistCampaigns}>
                <EditButton
                  record={record}
                  label=""
                />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewSpecialistCampaigns}>
                <ShowButton
                  record={record}
                  label=""
                />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски"
            sortable={false}
          />
          <DateField
            source="registrationStartsOn"
            label="Начало на регистрация"
            locales="bg-BG"
            showTime
            sortable={false}
          />
          <DateField
            source="registrationEndsOn"
            label="Край на регистрация"
            locales="bg-BG"
            showTime
            sortable={false}
          />
          <ReferenceField
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
            label="Структурна единица"
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <SecuredComponent permission={permissions.canManageSpecialistCampaigns}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewSpecialistCampaigns}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListCampaigns;
